export default {
  page: {
    limit: 20,
    skip: 0,
  },
};
